const locale = {
  summaryHeader: 'Summary',
  shipping: 'Shipping',
  shippingFree: 'FREE',
  pretaxTotal: 'Pretax Total',
  youllSave: 'You\'ll Save*',
  mandiButtonText: 'Find a Pro Installer**',
  mandiButtonTextMobile: 'Find Installer**',
  mandiText: '**Professional installation requires professional measure.',
  promoCodeText: '*Apply code <span class="promo-hightlight">{{promoCode}}</span> at checkout. ',
  promoEndDateText: 'Promo valid through <span class="promo-hightlight">{{promoEndDate}}</span>.',
};
export default locale;
